import { GALLERY_STATES } from "@volgo/core/contract";
import { addTag, removeTag, type SearchQuery } from "../search/query";
import { effectiveStates, toggleState } from "../search/tokens";
import { STATE_LABELS } from "./labels";
import { Segmented } from "./Segmented";

const RATINGS = [
  { value: "all", label: "전체" },
  { value: "3", label: "3 이상" },
  { value: "4", label: "4 이상" },
  { value: "4.5", label: "4.5 이상" },
] as const;

const STATES = GALLERY_STATES.map((value) => ({ value, label: STATE_LABELS[value] }));

const BLOCKED = [
  { value: "setting", label: "내 설정대로" },
  { value: "show", label: "보이기" },
  { value: "hide", label: "숨기기" },
] as const;

/** Language is a tag: these only put the tag into the search bar. */
const LANGUAGES = [
  { value: "language:korean", label: "한국어" },
  { value: "language:japanese", label: "일본어" },
  { value: "language:english", label: "영어" },
  { value: "language:chinese", label: "중국어" },
] as const;

/**
 * The conditions that are picked from a list: rating, state, blocked galleries. Picking one changes the
 * query; what was picked is SHOWN as a token in the search bar, and removed there too.
 */
export function ConditionsMenu({
  query,
  onChange,
}: {
  query: SearchQuery;
  onChange: (next: SearchQuery) => void;
}) {
  const states = effectiveStates(query);
  return (
    <div className="pop">
      <Segmented
        legend="평점"
        options={RATINGS}
        isOn={(v) => v === (query.ratingMin === null ? "all" : String(query.ratingMin))}
        onPick={(v) => onChange({ ...query, ratingMin: v === "all" ? null : Number(v) })}
      />
      <Segmented
        legend="상태"
        options={STATES}
        isOn={(v) => states.includes(v)}
        onPick={(v) => onChange(toggleState(query, v))}
      />
      <Segmented
        legend="차단 갤러리"
        options={BLOCKED}
        isOn={(v) => v === (query.blocked ?? "setting")}
        onPick={(v) => onChange({ ...query, blocked: v === "setting" ? null : v })}
      />
      <Segmented
        legend="언어 태그 바로 넣기"
        options={LANGUAGES}
        isOn={(v) => query.tags.includes(v)}
        onPick={(v) => onChange(query.tags.includes(v) ? removeTag(query, v) : addTag(query, v, "include"))}
      />
    </div>
  );
}
